import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';  // optional, if you have global styles

// Create root and render App into the #root div
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
